import React from 'react';
import ElementValidity from './ElementValidity';

const Canvas = React.forwardRef<HTMLCanvasElement, any>(
  ({ elements, ...props }, ref: any) => {
    return <canvas ref={ref} {...props} />;
  },
);

export default Object.assign(Canvas, {
  Elements: {
    Validity: ElementValidity,
  },
});
